import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useShopsContext } from '../../contexts/ShopsContext';
import './Search.scss';

const Search = ({
  onClick,
  backgroundColor = null,
  autofocus = false
}) => {

  const { t } = useTranslation();
  const { searchTerm, fetchClusters } = useShopsContext();
  const [value, setValue] = useState(searchTerm);

  useEffect(() => {
    setValue(searchTerm || '');
  }, [searchTerm])

  return (
    <div className="Search">
      <div className="Search__content" onClick={onClick}>
        <input
          type="text"
          placeholder={t('Shops.searchShop')}
          className={`${backgroundColor ?? ''}`}
          autoFocus={autofocus}
          value={value}
          onChange={(event) => {
            setValue(event.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') fetchClusters({
              search: value,
              zoom: 6,
            });
          }}
        />
        <button
          type="button"
          className="icon button-only-icon"
          onClick={() => {
            fetchClusters({
              search: value,
              zoom: 6
            });
          }}>
          <span className="sr-only">{t('Globals.search')}</span>
          <img src="/misc/icons/search.svg" alt=" " />
        </button>
      </div>
    </div>
  );
}

export default Search;